<template>
  <div class="advertisement" v-if="subjectType != 'ACTOR' && option.length != 0"  :option="option" :style="{width:width,height:height}">
    <template v-if="option.length != 0">
      <div class="advertisement-to-banner" v-if="option.length <= 1">
        <a @click="openUrl(option[0])"><img :src="option[0]['img']"/></a>
      </div>
      <div class="advertisement-to-banner" v-else>
        <swiper :options="swiperOption" class="swiper-container-topBanner">
          <swiper-slide class="swiper-slide-topBanner" v-for="(item, index) in option" :key="index" >
            <a  @click="openUrl(item)"><img :src="item.img"/></a>
          </swiper-slide>
        </swiper>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    option: {
      type: [Object, String, Array],
      default: () => ''
    },
    width: {
      type: [Object, String, Array],
      default: () => '1366px'
    },
    height: {
      type: [Object, String, Array],
      default: () => ''
    }
  },
  components: {},
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        loop: false,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        }
      }
    }
  },
  computed: {
    ...mapGetters(['language', 'subjectType'])
  },
  mounted() {},
  methods: {
    goLogin(){
      if (this.subjectType == '') {
        this.$store.commit('SET_SUBJECTTYPE', '')
        this.loginSource('/login/person')
      }
    },
    openUrl(data) {
      if (data.id) {
        if(data.type == 'actor') {
          this.openNewPage(`/find-exhibitor/detail/${data.id}`)
        } else if (data.type == 'product') {
          this.openNewPage(`/find-exhibit/detail/${data.id}`)
        }
      }
    }
  },
  created() {}
}
</script>

<style lang="stylus" scoped>
.advertisement{
  position relative
  margin 0 auto
  
  .advertisement-to-banner,
  .advertisement-to-banner a {
    display: block;
    width: 100%;
    height: 100%;
  }
}
img{
  width 100%
  height 100%
  object-fit cover
}
.swiper-container-topBanner{
  background  $color-black-25;
  height: 100%;
}
a {
  cursor pointer
}
</style>
